import { centsToDollars } from '@fruitful/fruitils';
import type { ImAccount } from '@fruitful/types';
import * as React from 'react';
import {
    BodyMediumEmphasized,
    ChevronRightIcon,
    FootnoteRegular,
    FruitfulCustomIcon,
    Icon,
    Private,
    XStack,
    YStack,
} from 'smoothie';

import { formatDollars } from '../../../common/utils/bankingUtils';

interface ApexAccountLineItemProps {
    onPress?: () => void;
    apexAccount?: ImAccount | null;
    placeholder?: string;
    showActionIcon?: boolean;
}

export const ApexAccountLineItem = ({
    apexAccount,
    onPress,
    placeholder,
    showActionIcon,
}: ApexAccountLineItemProps) => {
    const availableBalance = centsToDollars(
        apexAccount?.realtimeBalanceData.accountEquityCents ?? 0,
    );

    return (
        <XStack
            alignItems="center"
            justifyContent="space-between"
            gap={16}
            onPress={onPress}
            cursor="pointer"
            hoverStyle={{ backgroundColor: '$gray100' }}
            $sm={{ padding: 8, borderRadius: 12 }}
        >
            <XStack
                alignItems="center"
                gap={16}
                flexShrink={1}
                $platform-web={{ flexGrow: 1 }}
            >
                {apexAccount != null ? (
                    <>
                        <FruitfulCustomIcon
                            icon={apexAccount.icon}
                            color={apexAccount.color}
                            useAltColors={true}
                        />
                        <XStack
                            flex={1}
                            alignItems="center"
                            justifyContent="space-between"
                        >
                            <YStack flex={1}>
                                <BodyMediumEmphasized>
                                    {apexAccount.nickname ??
                                        'Investment account'}
                                </BodyMediumEmphasized>
                                <XStack alignItems="center" gap={8}>
                                    <FootnoteRegular color="$gray1000">
                                        {apexAccount.accountNumber}
                                    </FootnoteRegular>
                                </XStack>
                            </YStack>
                            <Private>
                                <BodyMediumEmphasized>
                                    {formatDollars(availableBalance)}
                                </BodyMediumEmphasized>
                            </Private>
                        </XStack>
                    </>
                ) : (
                    <>
                        <FruitfulCustomIcon
                            icon="fruitful"
                            color="peach"
                            useAltColors={true}
                        />
                        <BodyMediumEmphasized>
                            {placeholder}
                        </BodyMediumEmphasized>
                    </>
                )}
            </XStack>
            {showActionIcon && <Icon icon={ChevronRightIcon} size={16} />}
        </XStack>
    );
};
